import { booleanAttribute, Component, computed, inject, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemeService } from '../../services/local/theme.service';
import { IconButtonDirective } from '../button/icon/icon-button.directive';
import { Icon } from '../../types/icon.type';
import { ButtonSize, ButtonTheme } from '../button/base/base-button.component';

@Component({
  selector: 'immo-theme-picker',
  imports: [MatTooltipModule, IconButtonDirective],
  templateUrl: './theme-picker.component.html',
  styleUrl: './theme-picker.component.css',
})
export class ThemePickerComponent {
  private readonly themeService = inject(ThemeService);

  private readonly mode = this.themeService.theme;

  readonly theme = input<ButtonTheme>('surface-container-lowest');

  readonly size = input<ButtonSize>('md');

  readonly outlined = input<boolean, unknown>(false, {
    transform: booleanAttribute,
  });

  readonly icon = computed<Icon>(() => (this.mode() === 'dark' ? 'sun' : 'moon'));

  changeMode(): void {
    this.themeService.toggle();
  }
}
